// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const Backward10IconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="Backward10Icon" ref={forwardedRef} {...props}>
      <path d="M4.64 8.38h5v-1.5H7.043a5 5 0 0 1 3.452-1.38 5.003 5.003 0 0 1 5.006 5 5 5 0 0 1-3.507 4.773v1.554A6.504 6.504 0 0 0 17 10.501 6.503 6.503 0 0 0 10.494 4 6.5 6.5 0 0 0 6.14 5.67V3.38h-1.5v4.28L4.6 7.744h.04z" />
      <path d="M8.57 16.894c-1.311 0-2.127-1.016-2.127-2.664v-.568c0-1.648.816-2.656 2.128-2.656 1.32 0 2.144 1.008 2.144 2.656v.568c0 1.648-.824 2.664-2.144 2.664m-.935-2.56a3 3 0 0 0 .032.472l1.56-2.384a.78.78 0 0 0-.656-.344c-.584 0-.936.544-.936 1.48zm.288 1.152a.78.78 0 0 0 .648.336c.608 0 .96-.552.952-1.488l-.008-.776a4 4 0 0 0-.032-.456z" />
      <path d="M2.324 15.678v1.072h3.224v-1.072H4.572V11.15H3.7l-1.616.928.32.728.976-.296v3.168z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const Backward10Icon = /* @__PURE__ */ Object.assign(
  Backward10IconComponent,
  { displayName: 'Backward10Icon' },
);
